import validate from "/usr/src/nuxtapp/node_modules/nuxt/dist/pages/runtime/validate.js";
import _100_45decode_45path_45global from "/usr/src/nuxtapp/app/middleware/100.decode-path.global.js";
import _105_45redirect_45trailing_45slash_45global from "/usr/src/nuxtapp/app/middleware/105.redirect-trailing-slash.global.js";
import _115_45auth_45required_45global from "/usr/src/nuxtapp/app/middleware/115.auth-required.global.js";
import _116_45acknowledge_45global from "/usr/src/nuxtapp/app/middleware/116.acknowledge.global.js";
import _118_45spm_45global from "/usr/src/nuxtapp/app/middleware/118.spm.global.js";
import _161_45navigation_45global from "/usr/src/nuxtapp/app/middleware/161.navigation.global.js";
import _5_45redirect_45russian_45language_45global from "/usr/src/nuxtapp/app/middleware/5.redirect-russian-language.global.js";
import manifest_45route_45rule from "/usr/src/nuxtapp/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  _100_45decode_45path_45global,
  _105_45redirect_45trailing_45slash_45global,
  _115_45auth_45required_45global,
  _116_45acknowledge_45global,
  _118_45spm_45global,
  _161_45navigation_45global,
  _5_45redirect_45russian_45language_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "110-set-language-prefix-client": () => import("/usr/src/nuxtapp/app/middleware/110.set-language-prefix.client.js"),
  auth: () => import("/usr/src/nuxtapp/app/middleware/auth.js"),
  "catalog-pagination": () => import("/usr/src/nuxtapp/app/middleware/catalog-pagination.js"),
  guest: () => import("/usr/src/nuxtapp/app/middleware/guest.js"),
  "language-redirect": () => import("/usr/src/nuxtapp/app/middleware/language-redirect.js"),
  "page-404": () => import("/usr/src/nuxtapp/app/middleware/page-404.js"),
  "page-blog": () => import("/usr/src/nuxtapp/app/middleware/page-blog.js"),
  "page-cart": () => import("/usr/src/nuxtapp/app/middleware/page-cart.js"),
  "page-charts": () => import("/usr/src/nuxtapp/app/middleware/page-charts.js"),
  "page-checkout": () => import("/usr/src/nuxtapp/app/middleware/page-checkout.js"),
  "page-complete": () => import("/usr/src/nuxtapp/app/middleware/page-complete.js"),
  "page-content": () => import("/usr/src/nuxtapp/app/middleware/page-content.js"),
  "page-documents": () => import("/usr/src/nuxtapp/app/middleware/page-documents.js"),
  "page-faq": () => import("/usr/src/nuxtapp/app/middleware/page-faq.js"),
  "page-forgot-password": () => import("/usr/src/nuxtapp/app/middleware/page-forgot-password.js"),
  "page-glossary": () => import("/usr/src/nuxtapp/app/middleware/page-glossary.js"),
  "page-index": () => import("/usr/src/nuxtapp/app/middleware/page-index.js"),
  "page-login": () => import("/usr/src/nuxtapp/app/middleware/page-login.js"),
  "page-logout": () => import("/usr/src/nuxtapp/app/middleware/page-logout.js"),
  "page-profile": () => import("/usr/src/nuxtapp/app/middleware/page-profile.js"),
  "page-register-verify": () => import("/usr/src/nuxtapp/app/middleware/page-register-verify.js"),
  "page-register": () => import("/usr/src/nuxtapp/app/middleware/page-register.js"),
  "page-router": () => import("/usr/src/nuxtapp/app/middleware/page-router.js"),
  "page-search": () => import("/usr/src/nuxtapp/app/middleware/page-search.js"),
  "page-trade-complete": () => import("/usr/src/nuxtapp/app/middleware/page-trade-complete.js"),
  "page-trade": () => import("/usr/src/nuxtapp/app/middleware/page-trade.js"),
  permission: () => import("/usr/src/nuxtapp/app/middleware/permission.js")
}